import imageUrl_1 from './media/test_img_1.webp';
import imageUrl_2 from './media/test_img_2.webp';
import imageUrl_3 from './media/test_img_3.jpg';
import imageUrl_4 from './media/test_img_4.png';
import gifUrl_1 from './media/test_gif_1.gif';
import gifUrl_2 from './media/test_gif_2.gif';
import gifPreview_2 from './media/test_gif_2_preview.jpg';
import videoUrl_1 from './media/test_video_1.mp4';
import videoUrl_2 from './media/test_video_2.mp4';

//Данные для тестирования
export const testData = () => {
  return [
    {
      url: imageUrl_1,
      type: 'image',
      caption: 'Параллелипипед',
    },
    {
      url: imageUrl_2,
      type: 'image',
    },
    {
      url: gifUrl_1,
      type: 'gif',
      size: '10000',
      caption: 'GIF test',
    },
    {
      url: videoUrl_2,
      type: 'video',
    },
    {
      url: gifUrl_2,
      type: 'gif',
      size: '4194304',
      preview: gifPreview_2,
    },
    {
      url: imageUrl_3,
      type: 'image',
      caption: 'JPg test',
    },
    {
      url: videoUrl_1,
      type: 'video',
      caption: 'Video Test',
    },
    {
      url: imageUrl_4,
      type: 'image',
      caption: 'Png Test',
    },
  ]
}